module.exports = __webpack_public_path__ + "static/media/dollar_coin_silver.f939752c.png";